import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import { Card } from 'primereact/card'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomDataTableHeader,
  CustomPanel,
  CustomTabView,
  Loading,
  PageHeader,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import { formatIsoDateToLocale } from '../../../../services/util/date.service'
import { getReconferenciaEtiquetaDetail } from '../../../../services/api/https/picking/picking.http'

function ReconferenciaEtiquetaResultado({ dispatch, history, selectedTp }) {
  const [isLoading, setIsLoading] = useState(true)
  const [detail, setDetail] = useState(null)
  const [globalFilterItems, setGlobalFilterItems] = useState('')
  const [globalFilterHistory, setGlobalFilterHistory] = useState('')
  const [globalFilterLeftover, setGlobalFilterLeftover] = useState('')
  const [globalFilterMissing, setGlobalFilterMissing] = useState('')

  const conferenciaId = history.location.state && history.location.state.conferencia_id

  const formatDateTime = value => {
    if (!value) return '-'
    try {
      return formatIsoDateToLocale(value).toFormat('dd/MM/yyyy HH:mm:ss')
    } catch (e) {
      return value
    }
  }

  useEffect(() => {
    if (conferenciaId) {
      fetchDetail()
    }
  }, [conferenciaId])

  const fetchDetail = async () => {
    setIsLoading(true)
    try {
      const result = await getReconferenciaEtiquetaDetail(conferenciaId, selectedTp)
      setDetail(result)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  if (!conferenciaId) {
    history.goBack()
    return null
  }

  return (
    <>
      <PageHeader>Re-conferência - Etiqueta - Resultado</PageHeader>
      <div style={{ marginTop: 20 }} className="p-grid">
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : detail ? (
            <CustomTabView activeIndex={0}>
              <TabPanel header={'Informações'}>
                <div className="p-grid p-col-12">
                  <div className="p-col-12 p-md-6">
                    <Card title="Conferência">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Código</div>
                        <div style={{ width: 150 }}>{detail.info.id}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Pallet (ID)</div>
                        <div style={{ width: 150 }}>{detail.info.pallet_area_id}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Empresa</div>
                        <div style={{ width: 150 }}>{detail.info.empresa_nome}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Conferido Por</div>
                        <div style={{ width: 150 }}>{detail.info.conferido_por}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Status</div>
                        <div style={{ width: 150 }}>{detail.info.status}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>Criado em</div>
                        <div style={{ width: 150 }}>{formatDateTime(detail.info.created_at)}</div>
                      </div>
                    </Card>
                  </div>
                  {detail.info.status === 'Cancelado' && (
                    <div className="p-col-12 p-md-6">
                      <Card title="Cancelamento">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>Cancelado Por</div>
                          <div style={{ width: 150 }}>{detail.info.cancelado_por}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>Cancelado em</div>
                          <div style={{ width: 150 }}>{formatDateTime(detail.info.canceled_at)}</div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>Motivo</div>
                          <div style={{ width: 150 }}>{detail.info.canceled_reason}</div>
                        </div>
                      </Card>
                    </div>
                  )}
                </div>

                <CustomTabView activeIndex={0}>
                  <TabPanel header={'Pallet (Itens)'}>
                    <div style={{ overflowX: 'auto' }}>
                    <DataTable
                      header={<CustomDataTableHeader onChange={setGlobalFilterItems} />}
                      globalFilter={globalFilterItems}
                      responsive={true}
                      value={detail.items}
                      emptyMessage={'Nenhum item'}
                      paginator
                      rows={15}
                    >
                      <Column field="product_code" header="Código" style={{ ...tableCellCentered(Math.max(120, Math.max(...(detail.items || []).map(i => (i.product_code || '').length)) * 9)), whiteSpace: 'nowrap', overflow: 'hidden' }} sortable />
                      <Column field="product_name" header="Produto" sortable />
                      <Column field="qte_total" header="Qte. Esperada" style={tableCellCentered(120)} sortable />
                      <Column field="qte_picked" header="Qte. Conferida" style={tableCellCentered(120)} sortable />
                    </DataTable>
                    </div>
                  </TabPanel>

                  <TabPanel header={'Faltas'}>
                    <div style={{ overflowX: 'auto' }}>
                    <DataTable
                      header={<CustomDataTableHeader onChange={setGlobalFilterMissing} />}
                      globalFilter={globalFilterMissing}
                      responsive={true}
                      value={detail.missing}
                      emptyMessage={'Nenhuma falta registrada'}
                      paginator
                      rows={15}
                    >
                      <Column field="product_code" header="Código" style={{ ...tableCellCentered(Math.max(120, Math.max(...(detail.missing || []).map(i => (i.product_code || '').length)) * 9)), whiteSpace: 'nowrap', overflow: 'hidden' }} sortable />
                      <Column field="product_name" header="Produto" sortable />
                      <Column field="qtd_missed" header="Qte. Faltante" style={tableCellCentered(120)} sortable />
                    </DataTable>
                    </div>
                  </TabPanel>

                  <TabPanel header={'Sobras'}>
                    <div style={{ overflowX: 'auto' }}>
                    <DataTable
                      header={<CustomDataTableHeader onChange={setGlobalFilterLeftover} />}
                      globalFilter={globalFilterLeftover}
                      responsive={true}
                      value={detail.leftover}
                      emptyMessage={'Nenhuma sobra registrada'}
                      paginator
                      rows={15}
                    >
                      <Column field="product_code" header="Código" style={{ ...tableCellCentered(Math.max(120, Math.max(...(detail.leftover || []).map(i => (i.product_code || '').length)) * 9)), whiteSpace: 'nowrap', overflow: 'hidden' }} sortable />
                      <Column field="product_name" header="Produto" sortable />
                      <Column field="qte_picked" header="Qte. Excedente" style={tableCellCentered(120)} sortable />
                    </DataTable>
                    </div>
                  </TabPanel>
                </CustomTabView>
              </TabPanel>

              <TabPanel header={'Histórico'}>
                <div style={{ overflowX: 'auto' }}>
                <DataTable
                  header={<CustomDataTableHeader onChange={setGlobalFilterHistory} />}
                  globalFilter={globalFilterHistory}
                  responsive={true}
                  value={detail.history}
                  emptyMessage={'Nenhum histórico'}
                  paginator
                  rows={15}
                >
                  <Column field="product_code" header="Código" style={{ ...tableCellCentered(Math.max(120, Math.max(...(detail.history || []).map(i => (i.product_code || '').length)) * 9)), whiteSpace: 'nowrap', overflow: 'hidden' }} sortable />
                  <Column field="product_name" header="Produto" sortable />
                  <Column field="qtd_picked" header="Qte. Bipada" style={tableCellCentered(120)} sortable />
                  <Column field="created_at" header="Data" style={tableCellCentered(180)} sortable body={row => formatDateTime(row.created_at)} />
                </DataTable>
                </div>
              </TabPanel>
            </CustomTabView>
          ) : (
            <p>Conferência não encontrada</p>
          )}
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ReconferenciaEtiquetaResultado))
